import * as utils from "./src/utils";

// imports (general functionality)
import "./src/third-party/object.assign.pollyfill"
import "./src/third-party/object.getownpropertydescriptors.pollyfill"
import "./src/third-party/bootstrap/alert"
import "./src/third-party/bootstrap/collapse"
import "./src/third-party/bootstrap/dropdown"
import "./src/third-party/bootstrap/modal"
import "./src/third-party/bootstrap/tab"
import "./src/third-party/bootstrap/toast"
import "./src/third-party/bootstrap/tooltip"
import "./src/hover-intent"
import "./src/appear"
import "./src/parallax"
import "./src/modal-draggability"
import "./src/form-validation"
import "./src/box-zooming"
import "./src/shortcuts"
import "./src/tooltips"
// import "./src/popovers"
// import "./src/css-skins"
import "./src/treeview"
import "./src/input-inc-dec" // no need to export, auto-init is enough
// import "./src/wizard"
import "./src/dropdown"
import "./src/misc"

// global exports
export {
  // addClass,
  // removeClass,
  // toggleClass,
  toggleClassOnScroll,
  requestFullscreen,
  exitFullscreen,
  isFullscreen,
  htmlEntities,
  alterQueryString
} from "./src/utils"
export { AJAX } from "./src/ajax";
export { Modal } from "./src/modal"
export { makeExpandable } from "./src/dashboard-expandability"
export { ContextStorage } from "./src/context-storage"
export * from "./src/infinite-scroll"
// export * from "./src/css-tweakers"

// VOID namespace
import VOID from "./src/framework/framework"

VOID.utils.drag = utils.drag;
VOID.utils.ajax = utils.ajax;
VOID.utils.throttle = utils.throttle;
VOID.utils.debounce = utils.debounce;
VOID.utils.alterQueryString = utils.alterQueryString;
VOID.utils.ajaxValidation = utils.ajaxValidation;

import ClassDelayedToggler from "./src/class-delayed-toggler";
VOID.utils.ClassDelayedToggler = ClassDelayedToggler;

/*import {createMapsAPI} from "./src/google-maps"
VOID.Maps = createMapsAPI({
  language: "cs",
  key: "AIzaSyCfvJkpQTDWx1b621himqlAyDhwCV68qtE" // zbrane apikey
});*/

import * as _ from "./src/framework/voidash";
VOID._ = _;

import Lang from "./src/localization";
VOID.Lang = Lang;

export { VOID };
